import angular from 'angular';
import ngRedux from 'ng-redux';

/* Controller Imports */
import {ProfileComponent, ProfileController, EmailConfirmModalCtrl} from './edit-profile/edit.controller';
import ProfileDataFactory from './edit-profile/editProfile.service';
/* Service Imports */
import ProfileRouteConfig from './profile.route';
import VerifyEmailRouteConfig from './edit-profile/email/verifyEmailChange.route';
import ProfileSubscriptionsController from './subscriptions/subscriptions.controller';

const profileModule = angular
  .module('app.profile', [ngRedux, 'ui.bootstrap', 'ui.router', 'gettext'])
  .component('profileUser', ProfileComponent)
  /* Controllers */
  .controller('ProfileController', ProfileController)
  .controller('EmailConfirmModalCtrl', EmailConfirmModalCtrl)
  .controller('ProfileSubscriptionsController', ProfileSubscriptionsController)
  /* Services */
  .config(ProfileRouteConfig)
  .config(VerifyEmailRouteConfig)
  .factory('userDataFactory', ProfileDataFactory);

export default profileModule.name;
